import { useRouteInfoForCurrentPath } from 'app/shared/utils/useRouteInfoForCurrentPath';

// When we need to check a feature flag in the fan-facing nav, we add the flag here in NAVBAR_FEATURE_FLAGS,
// then import NAVBAR_FEATURE_FLAGS in navUtils.ts - see that file for more details
export const NAVBAR_FEATURE_FLAGS = [];

export const useFeatureFlagsForCurrentPath = () => {
  const routeInfo = useRouteInfoForCurrentPath();
  const featureFlagsToLoad = routeInfo?.featureFlagsToLoad || [];

  return [...new Set([...featureFlagsToLoad, ...NAVBAR_FEATURE_FLAGS])];
};
